import React from 'react'
// components
import MaterialPaper, { PaperProps } from '@mui/material/Paper'

const Paper: React.FC<PaperProps> = ({ children, ...rest }) => <MaterialPaper {...rest}>{children}</MaterialPaper>

export default Paper
